module.exports = __webpack_public_path__ + "static/media/main_slider_3.d6ef026f.jpg";